import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {hex2rgba} from '../theme/theme'

export const inputClasses = {
  textField: css`
    ${cssTheme.components.textFields.outline.bgColorError.token}: ${hex2rgba(cssTheme.colors.cinnabar.toxic.hex, 0.1)};

    & input::placeholder {
      color: ${cssTheme.default.day.textMinor};
      opacity: 1;
    }

    & input[type='number'] {
      -moz-appearance: textfield;
    }

    & input[type='tel'] {
      font-size: 16px;

      [dir='rtl'] & {
        direction: ltr;
        text-align: right;
      }
    }

    & input::-webkit-outer-spin-button,
    & input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  `,
  clearIcon: css`
    cursor: pointer;
  `,
}
